import { render } from "./SearchItem.vue?vue&type=template&id=53f0abce&scoped=true&ts=true"
import script from "./SearchItem.vue?vue&type=script&lang=ts"
export * from "./SearchItem.vue?vue&type=script&lang=ts"

import "./SearchItem.vue?vue&type=style&index=0&id=53f0abce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f0abce"]])

export default __exports__